import {stringifyEventData} from '../helpers/stringifyEventData';

export const trackMediaPollResult = ({
  channels,
  secondaryChannels,
  otherText,
}: {
  channels: string[];
  secondaryChannels: string[];
  otherText?: string;
}) => {
  const eventData = channels.sort(sortAlphabetically);

  const action = stringifyEventData(eventData);

  const label = stringifyEventData(
    [...secondaryChannels]
      .map(secondaryChannels => {
        if (secondaryChannels === 'TV_Other') {
          return 'TV_Other: ' + otherText;
        }

        if (secondaryChannels === 'MISC_Other') {
          return 'MISC_Other: ' + otherText;
        }

        return secondaryChannels;
      })
      .sort(sortAlphabetically)
  );

  const event = {
    event: 'Q&A Woher kennst du uns?',
    action,
    label,
  };

  return event;
};

function sortAlphabetically(a: string | undefined, b: string | undefined) {
  const textA = (a && a.toUpperCase()) || '';
  const textB = (b && b.toUpperCase()) || '';

  if (textA < textB) {
    return -1;
  } else if (textA > textB) {
    return 1;
  } else {
    return 0;
  }
}
